export class AgentViewModel {
  constructor(data) {
    this.IPAddress = data.IPAddress;
    this.NodeName = data.NodeName;
    this.NodeRole = data.NodeRole;
  }
}
